import { $api } from '#/api/client'

interface ICompanyStats {
  subscriptionPending: number
  subscriptionActive: number
  subscriptionTotal: number
  totalUsers: number
  totalInvoices: number
  totalSpending: number
}

interface IFetchCompanyStatsResponse {
  stats: ICompanyStats | undefined
  isLoading: boolean
  isError: boolean
}

export const useFetchCompanyStats = (companyId: string): IFetchCompanyStatsResponse => {
  const { data, isLoading, isError } = $api.useQuery(
    'get',
    '/stats/companies/{companyId}',
    { params: { path: { companyId } } },
    {
      enabled: companyId.length > 0,
      select: (response): ICompanyStats => ({
        subscriptionPending: response.subscriptionBreakdown.pending,
        subscriptionActive: response.subscriptionBreakdown.active,
        subscriptionTotal: response.subscriptionBreakdown.total,
        totalUsers: response.totalUsers,
        totalInvoices: response.totalInvoices,
        totalSpending: response.totalSpending,
      }),
    },
  )

  return {
    stats: data,
    isLoading,
    isError,
  }
}
